import React, { useEffect, useState, useRef, useMemo, Fragment } from "react";
import { Button, Input, Table, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTimes } from '@fortawesome/free-solid-svg-icons';
import './index.scss';
import { useDispatch, useSelector } from "react-redux";
import { documentLogListing } from '../../../context/actions/document';
import { incomeLogListing } from '../../../context/actions/irsIncome';
import LoaderUI from "../../../components/common/loader/index";
// import getAdminsList from "../../../../context/actions/admin"
import { getQueue } from "../../../context/actions/document"
import FilterList from "./FilterList";
import Listing from './Listing'
import NoRecord from '../../../components/common/NoRecord'


const DocumentLog = ({ incomeData, activeId }) => {
    console.log('income data -->', activeId)
    const fileData = useSelector((state) => state.document.fileData);
    const docId = fileData?._id;

    const tempItem = [0, 0, 0, 0, 0];

    const dispatch = useDispatch();
    const documentLogs = useSelector((state) => state?.document?.documentLogs);
    console.log('doc logs of Income page -->', documentLogs)
    const incomeLogs = useSelector((state) => state?.incomeAnalyzer?.incomeLogs)
    console.log('income logs data from reducer -->', incomeLogs)
    let [documentLogDetail, setDocumentLogDetail] = useState(null);


    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState("10");
    const [filter, setFilter] = useState('0')
    const [order, setOrder] = useState(-1);
    let [payload, setPayload] = useState({ page, limit });
    const [showLoader, setShowLoader] = useState(false);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [sort, setSort] = useState('time');
    const [loader, setLoader] = useState(false);
    const [reload, setReload] = useState(false);


    const isInitialRender = useRef(true);


    useEffect(() => {

        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }

        setLoader(true);
        dispatch(incomeLogListing(activeId, { ...payload, page: page, limit: limit, docId: docId, fields: "user", populate: 'user', sort, order, filter: searchKeyword }, (res) => {
            setLoader(false);
        }))
        // dispatch(documentLogListing({ ...payload, page: page, limit: limit, docId: docId, fields: "user", populate: 'user', sort, order, filter: searchKeyword }, (res) => {
        //     setLoader(false)
        // }))
    }, [reload])


    const handleLimit = (val) => {
        setLoader(true);
        console.log('handleLimit value', val)
        setLimit(val);
        setPage(1);
        setPayload({ ...payload, limit: val });
        dispatch(incomeLogListing(activeId, { ...payload, limit: val, docId: docId, filter: searchKeyword, fields: "user", populate: 'user', sort, order }, (res) => {
            setLoader(false);
        }))
    };

    const handlePageChange = async (activePage) => {
        setLoader(true);
        console.log('handlePageChange activepage', activePage)
        setPage(activePage)
        // setPayload({ ...payload, page: activePage });
        // dispatch(documentLogListing({ ...payload, page: activePage, limit: limit, docId: docId, fields: "user", populate: 'user', sort, order, filter: searchKeyword }, (res) => {
        //     setLoader(false)
        // }))
        dispatch(incomeLogListing(activeId, { ...payload, page: activePage, limit: limit, docId: docId, fields: "user", populate: 'user', sort, order, filter: searchKeyword }, (res) => {
            setLoader(false);
        }))
    };

    const handleFilter = () => {
        setLoader(true)
        dispatch(incomeLogListing(activeId, { page: 1, limit: limit, docId: docId, filter: searchKeyword, fields: "user", populate: 'user', sort: 'updatedAt', order: - 1 }, (res) => {
            setLoader(false);
        }))
        // dispatch(documentLogListing({ page: 1, limit: limit, docId: docId, filter: searchKeyword, fields: "user", populate: 'user', sort: 'updatedAt', order: - 1 }, (res) => {
        //     setLoader(false)
        // }))
        setPage(1)
    };

    const clear = () => {
        setLoader(true)
        setSearchKeyword('')

        dispatch(incomeLogListing(activeId, { limit: limit, page, docId: docId }, (res) => {
            setLoader(false);
        }))

        // dispatch(documentLogListing({ limit: limit, page, docId: docId }, (res) => {
        // setLoader(false);
        // setSearchInProgress(false)
        // }));
    }

    const sortFn = (params) => {

        setLoader(true);
        setOrder(params?.order)
        setSort(params?.key)
        console.log('params of sortFn', params)
        let param = { ...params, limit, page: 1, filter: searchKeyword }
        if (params?.key) {
            param.sort = params?.key
        }
        // dispatch(documentLogListing(param, (res) => {
        //     setLoader(false)
        // }));
        dispatch(incomeLogListing(activeId, param, (res) => {
            setLoader(false);
        }))
        setPage(1)
    }

    useEffect(() => {
        console.log('params for useEffect', docId);
        // dispatch({ type: "RESET_DOCUMENT_LOGS_LISTING", data: {} });
        dispatch({ type: "RESET_INCOME_LOGS_LISTING", data: {} });
        setLoader(true)
        dispatch(incomeLogListing(activeId, { ...payload, page: page, limit: limit, docId: docId, sort, order, filter: searchKeyword }, (res) => {
            setLoader(false);
        }))
        // dispatch(documentLogListing({ ...payload, limit: limit, page: page, docId: docId, fields: "user", populate: 'user' }, (res) => {
        //     setLoader(false)
        // })) // brings DocumentLog data from database
    }, [])

    const calculatePaginationStats = (data, page, limit) => {
        const totalCurrentDoc = data.totalCount; // Assuming totalCount is the total number of documents
        const totalPages = Math.ceil(totalCurrentDoc / limit);

        return {
            hasNextPage: page < totalPages,
            hasPrevPage: page > 1,
            limit,
            nextPage: page < totalPages ? page + 1 : null,
            page: page,
            pagingCounter: (page - 1) * limit + 1,
            prevPage: page > 1 ? page - 1 : null,
            totalCurrentDoc,
            totalPages,
        };
    }

    let paginationStats;

    paginationStats = incomeLogs?.result ? calculatePaginationStats(incomeLogs, page, limit) : null;

    return (
        <>
            {/* <div className="file-version-blc d-inline-flex align-items-center text-start">
                <div className="left-col">
                    <a href="#" className='lbl'>
                        {fileData?.folder?.loan_number}
                    </a>
                    <span className="arrow-icon">
                        &raquo;
                    </span>
                    <label className='des'>
                        {fileData?.name}
                    </label>
                </div>
            </div> */}
            <div className="inner">
                <div className='table-wrapper'>

                    <FilterList searchKeyword={searchKeyword} _setSearchKeyword={setSearchKeyword} _handleFilter={handleFilter} _clear={clear} reload={reload} _setReload={setReload} />

                    {/* {console.log('documentLogs?.totalCurrentDoc?.length =>', documentLogs)} */}
                    {loader ? <LoaderUI message={false} FullWindow={false} inContainer={true} /> : incomeLogs?.result?.length ? (


                        <div className='table-wrapper'>


                            <div className='card shadow'>
                                <Listing _sortFn={sortFn} sort={sort} order={order} documentLogs={incomeLogs}
                                    page={page} limit={limit} _handleLimit={handleLimit} _handlePageChange={handlePageChange}
                                    documentLogDetail={documentLogDetail} _setDocumentLogDetail={setDocumentLogDetail}
                                    fileData={incomeData} paginationStats={paginationStats} />
                            </div>
                        </div>)
                        :
                        <div>
                            <div className="card"><NoRecord /></div>
                        </div>
                    }

                </div>
            </div>
        </>

    );
};
export default DocumentLog;